// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1X_JO","footer":"ModalCreateQualiphyProcedure_footer__33040","additionData":"ModalCreateQualiphyProcedure_additionData__3n7i8"};